import { 
    GET_HEADING_LIST,
    GET_HEADING_LIST_SUCCESS,
    GET_HEADING_LIST_FAILURE, 
    CREATE_HEADING,
    CREATE_HEADING_SUCCESS,
    CREATE_HEADING_FAILURE,
    VIEW_HEADING_SUCCESS,
    VIEW_HEADING_FAILURE,
    VIEW_HEADING,
    UPDATE_HEADING_SUCCESS,
    UPDATE_HEADING_FAILURE,
    UPDATE_HEADING,
    CHANGE_HEADING_STATUS,
    CHANGE_HEADING_STATUS_SUCCESS,
    CHANGE_HEADING_STATUS_FAILURE,
  } from "../types";
  
  export const getHeadingList = (payload) => ({
    type: GET_HEADING_LIST,
    payload,
  });
  
  export const getHeadingListSuccess = (payload) => ({
    type: GET_HEADING_LIST_SUCCESS,
    payload,
  });
  
  export const getHeadingListFailure = (payload) => ({
    type: GET_HEADING_LIST_FAILURE,
    payload,
  });

  export const createHeading = (payload) => ({
    type: CREATE_HEADING,
    payload,
  });
  
  export const createHeadingSuccess = (payload) => ({
    type: CREATE_HEADING_SUCCESS,
    payload,
  });
  
  export const createHeadingFailure = (payload) => ({
    type: CREATE_HEADING_FAILURE,
    payload,
  });

  export const viewHeading = (payload) => ({
    type: VIEW_HEADING,
    payload,
  });
  
  export const viewHeadingSuccess = (payload) => ({
    type: VIEW_HEADING_SUCCESS,
    payload,
  });
  
  export const viewHeadingFailure = (payload) => ({
    type: VIEW_HEADING_FAILURE,
    payload,
  });
  
  export const updateHeading = (payload) => ({
    type: UPDATE_HEADING,
    payload,
  });
  
  export const updateHeadingSuccess = (payload) => ({
    type: UPDATE_HEADING_SUCCESS,
    payload,
  });
  
  export const updateHeadingFailure = (payload) => ({
    type: UPDATE_HEADING_FAILURE,
    payload,
  });
  
  export const changeheadingstatus = (payload) => ({
    type:  CHANGE_HEADING_STATUS,
    payload,
  });

  export const changeheadingstatussuccess = (payload) => ({
    type:  CHANGE_HEADING_STATUS_SUCCESS,
    payload,
  });

  export const changeheadingstatusfailure = (payload) => ({
    type:  CHANGE_HEADING_STATUS_FAILURE,
    payload,
  });